import RatingPage from '@app-studio-web/ui/pages/RatingPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function MoneyControlPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <RatingPage
      heading={t('pages.onboarding.moneyControl.heading')}
      leftText={t('pages.onboarding.moneyControl.options.1')}
      rightText={t('pages.onboarding.moneyControl.options.5')}
      onSubmit={handleSubmit}
      buttonBgColor="bg-white"
      headingSize="text-3xl"
    />
  )
}
